import { getObjectProperty } from "./index";

export interface AttributeCollection { [key: string]: number | string };

export interface ElementOptions
{
    classNames?: string[];
    attributes?: AttributeCollection;
    innerHTML?: string;
    childElements?: Element[];
    parentElement?: Element;
}

export function createElement(tagName: string, options?: ElementOptions): HTMLElement
{
    let element = document.createElement(tagName);
    let classNames = getObjectProperty<string[]>(options, 'classNames', []);
    let attributes = getObjectProperty<AttributeCollection>(options, 'attributes', {});
    let childElements = getObjectProperty<Element[]>(options, 'childElements', []);
    let parentElement = getObjectProperty<Element>(options, 'parentElement');
    let innerHTML = getObjectProperty<string>(options, 'innerHTML');
    
    if (classNames !== undefined && classNames.length > 0)
    {
        element.classList.add(...classNames);
    }

    if (attributes !== undefined)
    {
        for (let attributeName in attributes)
        {
            element.setAttribute(attributeName, attributes[attributeName] as string);
        }
    }

    if (childElements.length > 0)
    {
        for(let child of childElements)
        {
            if (child.parentElement)
            {
                child.parentElement.removeChild(child);
            }

            element.appendChild(child);
        }
    }

    if (parentElement !== undefined)
    {
        parentElement.appendChild(element);
    }

    if (innerHTML !== undefined)
    {
        element.innerHTML = innerHTML;
    }

    return element;
}

/**
 * Typed variant of createElement.
 * @param tagName Name of the HTML tag.
 * @param options Additional options used to create the element.
 */
export function createElementAs<T extends HTMLElement>(tagName: string, options: ElementOptions): T
{
    return <T>createElement(tagName, options);
}

/**
 * Removes all child elements of an element.
 * Returns an array of removed child elements.
 * @param element Target element.
 */
export function emptyElement(element: Element): Element[]
{   
    let result = [];
    if (element) 
    {
        while(element.firstChild)
        {
            result.push(element.firstChild);
            element.removeChild(element.firstChild);
        }
    }

    return result;
}

export function replaceElements(element: Element, replacements: Element | Element[])
{
    if (!Array.isArray(replacements))
    {
        replacements = [replacements];
    }

    emptyElement(element);
    
    for(let replacement of replacements)
    {
        element.appendChild(replacement);
    }
}